/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlGrantScope = {
    Impersonation: 'IMPERSONATION'
} as const;
export type ControlGrantScope = typeof ControlGrantScope[keyof typeof ControlGrantScope];


export function ControlGrantScopeFromJSON(json: any): ControlGrantScope {
    return ControlGrantScopeFromJSONTyped(json, false);
}

export function ControlGrantScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGrantScope {
    return json as ControlGrantScope;
}

export function ControlGrantScopeToJSON(value?: ControlGrantScope | null): any {
    return value as any;
}

